export const BRANDS = [
  "None",
  "Chevrolet",
  "CJDR",
  "Ford",
  "Honda",
  "Hyundai",
  "INFINITI",
  "Kia",
  "Lincoln",
  "Mazda",
  "Mitsubishi",
  "Nissan",
  "Toyota"
];

// Brands that skip the local builder and open their own dealerdraft site.
// `slug` is optional and defaults to the lowercased brand name.
export const BRANDED_SITE_BRANDS = {
  CJDR: { slug: "stellantis" }
};

export const getBrandedSiteUrl = brand => {
  const config = BRANDED_SITE_BRANDS[brand];
  if (!config) return null;
  const slug = config.slug || brand.toLowerCase();
  return `https://dealerdraft-${slug}.sokalsites.com`;
};
